import React, { useState, useEffect } from "react";

import Editor from "@monaco-editor/react";

const CodeEditorWindow = ({ onChange, language, code, theme }) => {
  const [value, setValue] = useState(code || "");

  useEffect(()=>{
    setValue(code);
  },[code])
  const handleEditorChange = (value) => {
    setValue(value);
    onChange("code", value);
  };

  return (
      <Editor
        language={language || "javascript"}
        value={value}
        theme={theme}
        defaultValue=""
        onChange={handleEditorChange}
      />
  );
};
export default CodeEditorWindow;
